<template lang="html">
  <div class="">
    <div class="page-submenu">
      <div class="page-submenu_left">
        <div class="content-box">
          <left-bar tab='3'></left-bar>
        </div>
      </div>
      <div class="page-submenu_right">
        <div class="content-box">
          <div class="search-content">
              <div class="search-content-fields">
                <div>
                  <el-form label-position="top">
                      <el-row>
                        <div class="col-full">
                          <el-form-item label="公告内容">
                              <el-input v-model="searchData.contentCn"></el-input>
                          </el-form-item>
                        </div>
                      </el-row>
                      <el-row>
                          <el-col>
                              <el-form-item label="开始展示日期">
                                  <el-date-picker type="date" placeholder="请选择"  v-model="searchData.releaseTime"></el-date-picker>
                              </el-form-item>
                          </el-col>
                          <el-col>
                              <el-form-item label="停止展示日期">
                                  <el-date-picker type="date" placeholder="请选择"  v-model="searchData.removeTime"></el-date-picker>
                              </el-form-item>
                          </el-col>
                          <el-col>
                              <el-form-item label="操作人">
                                  <el-select @change="remoteCreateByData=[]" filterable remote :remote-method="handleUpdateByFilter" clearable placeholder="请输入" v-model="searchData.createBy">                            
                                    <el-option v-for="item in remoteCreateByData" :key="item.username" :value="item.username" :label="item.realname">
                                        <span>{{ item.realname}}</span>
                                    </el-option>
                                </el-select>
                              </el-form-item>
                          </el-col>
                      </el-row>
                  </el-form>             
                </div>
                <div class="search-btn">
                  <el-button type="primary" @click="handleSearch()">搜索</el-button>
                </div>
                     
              </div>
          </div>
          <div class="operate">
            <div>
              <el-button class="batch-download-btn" type="primary" @click="handlerExportExcelClick()" plain>批量导出</el-button>
              <el-button class="batch-delete-btn" :disabled="selectedData.length <= 0" type="primary" @click="handleBatchDeleteClick()" plain>批量删除</el-button>
              <el-button class="add-btn" type="primary" @click="handleAddNewClick()">发布公告</el-button>
            </div>
          </div>
          <common-crud ref="crud"
            :searchData="searchData"
            :tableData.sync="noticeData"
            :addNewOrEditData="addNewOrEditData"
            :crudApi="crudApi"
            :showEditFormTitle="false"
            :beforeSave="beforeSave"
            :selectedDataArray.sync="selectedData"
            :afterSave="handleSystemNoticesChange"
            :afterDelete="handleSystemNoticesChange"
            addSuccessMessages="发布系统公告成功"
            editSuccessMessages="编辑系统公告成功"
            deleteSuccessMessages="删除系统公告成功"
            deleteBatchSuccessMessages="批量删除系统公告成功"
          >
            <template slot="result">
              <el-table-column type="selection" width="55">
              </el-table-column>
              <el-table-column sortable prop="contentCn" label="公告内容" show-overflow-tooltip>
              </el-table-column>
              <el-table-column :formatter="formatDateTime2Date" sortable prop="releaseTime" label="开始展示日期" width="150">
              </el-table-column>
              <el-table-column :formatter="formatDateTime2Date" sortable prop="removeTime" label="停止展示日期" width="150">
              </el-table-column>              
              <el-table-column :formatter="formatDateTime2Date" sortable prop="updateTime" label="操作时间">
              </el-table-column>                            
              <el-table-column sortable prop="updateBy" label="操作人">
              </el-table-column>                                          
              <el-table-column fixed="right" label="操作" width="110">
                <template slot-scope="scope">
                  <div class="table-column-operate">
                    <el-button type="text" @click="handleEditClick(scope.row)">
                      编辑
                    </el-button>
                    <el-button type="text" @click="handleDeleteClick(scope.row)">
                      删除
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </template>
            <template slot="customTitle">公告信息</template>
            <template slot="editForm">
                <el-row>
                  <div class="col-full">
                    <el-form-item required label="公告内容" prop="contentCn">
                      <el-input maxlength="200" type="textarea" v-model="addNewOrEditData.contentCn" placeholder="请输入公告内容（建议75个字符以内）"></el-input>
                    </el-form-item>
                  </div>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item required label="开始展示日期" prop="releaseTime">
                        <el-date-picker :picker-options="startPickerOptions" type="date" v-model="addNewOrEditData.releaseTime" placeholder="请选择" ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item required label="停止展示日期" prop="removeTime">
                        <el-date-picker :picker-options="endPickerOptions" type="date" v-model="addNewOrEditData.removeTime" placeholder="请选择" ></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
            </template>
            <template slot="confirmAddNewMessage">
              <div>
                <span>确认发布公告？</span>
              </div>
            </template>
            <template slot="confirmEditMessage">
              <div>
                <span>确认保存公告？</span>
              </div>
            </template>
            <template slot="confirmDeleteMessage">
              <div>
                <span>删除发布公告？</span>
              </div>
            </template>
            <template slot="confirmBatchDeleteMessage">
              <div>
                <span>批量删除公告？</span>
              </div>
            </template>
          </common-crud>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import systemnotice from '@/api/sysmanagement/systemnotice';
import LeftBar from '../LeftBar';
import { mapActions } from 'vuex';

export default {
  components: {
    LeftBar
  },
  data() {
    return {
      noticeData :[],
      searchData: {
        contentCn:'',
        releaseTime: '',
        removeTime: '',
        createBy: ''
      },
      addNewOrEditData: {
        contentCn:'',
        releaseTime: '',
        removeTime: ''
      },
      selectedData: [],
      crudApi: systemnotice,
      startPickerOptions: {
        disabledDate: (time)=> {
            time = new Date(moment(time).format('YYYY-MM-DD'));
            if(!this.addNewOrEditData.removeTime) {
              return false;
            }
            return time.getTime() > this.addNewOrEditData.removeTime;
          }
      },
      endPickerOptions: {
        disabledDate: (time)=> {
            time = new Date(moment(time).format('YYYY-MM-DD'));
            if(!this.addNewOrEditData.releaseTime) {
              return false;
            }
            return time.getTime() < this.addNewOrEditData.releaseTime;
          }
      },
      remoteCreateByDataAll: [],
      remoteCreateByData: [],
    }
  },
  methods: {
    ...mapActions(['initSystemNotices']),
    formatDateTime2Date(row, column, cellValue, index) {
      return this.$refs['crud'].formatDateTime2Date(row, column, cellValue, index);
    },
    handleSearch() {
      if(this.searchData.releaseTime) {
        this.searchData.releaseTime = moment(this.searchData.releaseTime).format('YYYY-MM-DD HH:mm:ss');
      }
      if(this.searchData.removeTime) {
        this.searchData.removeTime = moment(this.searchData.removeTime).format('YYYY-MM-DD HH:mm:ss');
      }
      this.$refs['crud'].handleSearch(1);      
    },
    handleAddNewClick() {
      this.$refs['crud'].handleAddNew();
    },
    handleEditClick(item) {      
      this.$refs['crud'].handleEdit(item);
    },
    beforeSave(saveData) {
      saveData.releaseTime = moment(saveData.releaseTime).format('YYYY-MM-DD HH:mm:ss');
      saveData.removeTime = moment(saveData.removeTime).format('YYYY-MM-DD HH:mm:ss');
    },
    handleDeleteClick(item) {
      this.$refs['crud'].handleDelete(item);
    },
    handleBatchDeleteClick() {
      this.$refs['crud'].handleBatchDelete();
    },
    handlerExportExcelClick() {
      this.$refs['crud'].handlerExportExcel('系统公告.xlsx');
    },
    handleSystemNoticesChange() {
      this.initSystemNotices();
      this.initUserList();
    },
    handleUpdateByFilter(query) {
        if(!query) {
            this.remoteCreateByData = [];
            return;
        }
      
        this.remoteCreateByData =  this.remoteCreateByDataAll.filter(r => r.username.toLowerCase().indexOf(query.toLowerCase()) >= 0);
    },
    initUserList() {
      systemnotice.getUserList()
                      .then(res => {
                        this.remoteCreateByDataAll = res;
                      })
    }
  },  
  mounted() {    
    this.handleSearch();  
    this.initUserList();
  }
};
</script>

<style lang="less" scoped>
  .search-content {
    display: flex;
    margin-bottom: 22px;

    .search-content-fields {
      display: flex;

      .el-row {
        .col-full {
          width: 698px;
        }

        .el-col {
          width: 220px;
        }

        .el-col + .el-col {
          margin-left: 28px;
        }
      }
      
      .search-btn {
        margin-top: 125px;
        margin-left: 14px;

        button {
          width: 120px;
        }
      }
    }
  }
  .operate {
    float: right;
    margin-bottom: 30px;

    .add-btn {
      width: 120px;
    }

    .batch-download-btn, .batch-delete-btn {
      width: 87px;
      padding: 0;
    }

    .el-button + .el-button {
       margin-left: 26px;
    }
  }
</style>



// WEBPACK FOOTER //
// index.vue?58525fc3